import type { Provider } from '../types'

export function isRecommendedProvider(provider: Provider) {
  return provider.type !== 'BANK' && provider.slug !== 'paypal'
}
